import { sha256 } from 'js-sha256';

const generateSHA256 = (message: string): string => {
    return sha256(message);
};

export const generateHeaderHash = (headers: string[]): string => {
    const sortedHeaders = headers.sort().join('|');
    return generateSHA256(sortedHeaders);
};